module.exports = __webpack_public_path__ + "img/control_de_calidad_3-4_1152.b8d195ce.webp";